import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { useFormik } from "formik";
import BeatLoader from "react-spinners/BeatLoader";
import { fireLoginOtp, loginWithOtp } from "../../src/store/action/cart/editCart";
import { useSelector } from "react-redux";
import XIcon from "../Images/X.svg";
import { MdKeyboardArrowRight, MdKeyboardArrowLeft } from "react-icons/md";

function PhoneModal(props) {
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const phoneRef = useRef();
  const branchId = parseInt(localStorage.getItem("branchId"));
  const phoneForBranch38 = "0500000006";
  const { lang } = useSelector((state) => state.language);
  const [errorMsg, setErrorMsg] = useState("");
  const [canResend, setCanResend] = useState(true);
  const [resendTimer, setResendTimer] = useState(0);


  const phoneSchema = yup.object().shape({
    phone: yup
      .string()
      .matches(
        /^(05)[0-9]{8}$|^(03)[0-9]{8}$|^(3)[0-9]{7}$|^(6)[0-9]{7}$|^(7)[0-9]{7}$/,
        {
          message: t("LandingPage.validation"),
          excludeEmptyString: true,
        }
      ),
  });

  const resetForm = () => {
    setOtpSent(false);
    setOtp("");
    setCanResend(true);
    setResendTimer(0);
    formik.resetForm();
  };


  const handleResendOtp = async () => {
    if (!canResend) return;
    setLoading(true);
    setCanResend(false);

    const phone = formik.values.phone.trim() || phoneForBranch38;

    try {
      await fireLoginOtp(phone);
      showError(t("تم إرسال رمز جديد") || "New OTP sent.");

      // Start 30s countdown
      let counter = 30;
      setResendTimer(counter);
      const interval = setInterval(() => {
        counter -= 1;
        setResendTimer(counter);
        if (counter === 0) {
          clearInterval(interval);
          setCanResend(true);
        }
      }, 1000);
    } catch (error) {
      console.error("Resend OTP failed:", error);
      showError(t("فشل في إعادة إرسال الرمز") || "Failed to resend OTP.");
      setCanResend(true);
    } finally {
      setLoading(false);
    }
  };
  const showError = (message) => {
    setErrorMsg(message);
    setTimeout(() => {
      setErrorMsg("");
    }, 3000); // 3 seconds
  };

  const formik = useFormik({
    initialValues: {
      phone: "",
    },
    validationSchema: phoneSchema,
    onSubmit: async (values) => {
      setLoading(true);
      let phone = values.phone.trim();
      if (branchId === 39 && !phone) phone = phoneForBranch38;

      localStorage.setItem("phoneNumber", phone);

      try {
        await fireLoginOtp(phone);
        setOtpSent(true);
      } catch (error) {
        console.error("OTP send failed:", error);
        showError(t("خطا في ارسال الرمز") || "Failed to send OTP.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleVerifyOtp = async () => {
    // Prevent submission if OTP is empty or already loading
    if (!otp.trim() || loading) {
      return;
    }

    setLoading(true);
    const phone = formik.values.phone.trim() || phoneForBranch38;

    try {
      const res = await loginWithOtp(phone, otp);
      const token = res.data.data.accessToken;
      const userId = res.data.data.userId;

      localStorage.setItem("TOKEN", JSON.stringify(token));
      localStorage.setItem("userId", JSON.stringify(userId));
      props.setHasToken(true);
      props.setModal(false);
      props.handleAdd();
    } catch (error) {
      console.error("OTP login failed:", error);
      showError(t("LandingPage.errorSendingOtp") || "Invalid OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleAsGuest = () => {
    localStorage.removeItem("phoneNumber")
    localStorage.setItem("TOKEN", JSON.stringify("token"));
    localStorage.setItem("userId", "userId");
    props.setHasToken(true);
    props.setModal(false);
    props.handleAdd();
  }

  return (
    <div>
      <div className="Modal">
        <div onClick={() => props.setModal(false)} className="modalOverlay" />
        <div
          className={
            lang === "ar" ? "modal-content" : "modal-content modal-contentEn"
          }
          style={{
            width: lang === "ar" ? "60vw" : "80%",
            maxWidth: "500px",
            minWidth: "330px",
            left: lang === "ar" ? "50%" : "50%",
            top: lang === "ar" ? "50%" : "50%",
            transform: lang === "ar" ? "translate(-50%, -50%)" : "translate(-50%, -50%)",
            backgroundColor: "#FFFFFF",
            borderRadius: "12px",
            position: "absolute",
          }}
        >
          <button 
            onClick={() => props.setModal(false)}
            style={{
              position: "absolute",
              top: "10px",
              right: lang === "ar" ? "auto" : "15px",
              left: lang === "ar" ? "15px" : "auto",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: "5px",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src={XIcon} alt="Close" style={{ width: "42px", height: "42px" }} />
          </button>
          {loading ? (
            <div className="loader" style={{ height: "220px" }}>
              <BeatLoader color="#E57200" loading={loading} size={30} />
            </div>
          ) : (
            <div className="modalBody" style={{ textAlign: "center", padding: "1em" }}>
              <div>
                <p
                  className="offer"
                  style={{
                    direction: lang === "ar" ? "rtl" : "ltr",
                    fontWeight: "600",
                    fontSize: "20px",
                  }}
                >
                  {t("LandingPage.text")}
                </p>
                <p
                  className="phoneModalText"
                  style={{
                    direction: lang === "ar" ? "rtl" : "ltr",
                    color: "#665252",
                    
                  }}
                >
                  {lang === "ar"
                    ? <>
                      للحصول علي العروض و الخصومات و الكوبنات برجاء ادخال رقم الهاتف{" "}

                    </>
                    : <>
                      To get offers and discounts, please enter your phone number {" "}

                    </>
                  }
                </p>

              </div>

              <form onSubmit={(e) => {
                e.preventDefault();
                if (!otpSent) {
                  formik.handleSubmit(e);
                }
              }} className="phoneForm">
                <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                  <input
                    value={formik.values.phone}
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder={`${t("LandingPage.input")} ${branchId === 39 ? `(${t("LandingPage.optional")})` : ""}`}
                    ref={phoneRef}
                    required={branchId !== 39}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={otpSent}   // disable when otp is sent
                    style={{
                      flex: 1,
                      boxShadow: "none",
                      border: "1.5px solid #E9E2E3",
                      borderRadius: "12px",
                      ...(lang === "ar"
                        ? { textAlign: "right", paddingRight: "40px", direction: "rtl" }
                        : { textAlign: "left", paddingLeft: "40px", direction: "ltr" })
                    }}
                  />

                  {otpSent && (
                    <button
                      type="button"
                      onClick={resetForm}
                      style={{
                        position: "absolute",
                        right: lang === "ar" ? "auto" : "10px",
                        left: lang === "ar" ? "10px" : "auto",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        color: "#E57200"
                      }}
                    >
                      ✏️
                    </button>
                  )}
                </div>
                <span style={{ marginBottom: "0.5em" }}>
                  {formik.errors.phone && formik.touched.phone && branchId !== 39
                    ? t("LandingPage.validation")
                    : null}
                </span>

                {!otpSent ? (
                  <div className="modalOption" style={{ display: "flex", flexDirection: "row-reverse", gap: "10px", marginTop: "0.3em" }}>
                    <button type="submit" className="confirm" style={{ flex: 1 }}>
                      {t("continue")}
                    </button>
                    <button
                      type={branchId === 39 ? "submit" : "button"}
                      onClick={branchId === 39 ? null : () => {
                        handleAsGuest()
                      }}
                      className="cancel"
                      style={{ 
                        flex: 1, 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        gap: "5px", 
                        whiteSpace: "nowrap",
                        direction: lang === "ar" ? "rtl" : "ltr"
                      }}
                    >
                      {branchId === 39 ? t("Basket.skip") : t("continueAsGuest")}
                      {lang === "ar" ? (
                        <MdKeyboardArrowLeft style={{ fontSize: "20px", flexShrink: 0 }} />
                      ) : (
                        <MdKeyboardArrowRight style={{ fontSize: "20px", flexShrink: 0 }} />
                      )}
                    </button>
                  </div>
                ) : (
                  <>
                    {otpSent && (
                      <>
                        <input
                          type="text"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && otp.trim() && !loading) {
                              handleVerifyOtp();
                            }
                          }}
                          placeholder={t("enterOtp") || "Enter OTP"}
                          style={{
                            marginTop: "1em",
                            textAlign: "center",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            width: "100%",
                            boxSizing: "border-box"
                          }}
                        />

                        <button
                          type="button"
                          className="resend"
                          onClick={handleResendOtp}
                          disabled={!canResend}
                          style={{
                            background: "transparent",
                            border: "none",
                            color: canResend ? "#E57200" : "#aaa",
                            cursor: canResend ? "pointer" : "not-allowed",
                            fontWeight: "600",
                            marginTop: "0.5em"
                          }}
                        >
                          {canResend
                            ? (t("resendOTp") || "Resend OTP")
                            : `${t("ResendIn") || "Resend in"} ${resendTimer}`}
                        </button>

                        <div className="modalOption" style={{ marginTop: "1em", display: 'flex', flexDirection: "row", gap: "10px", width: "100%" }}>
                          <button 
                            type="button" 
                            className="confirm" 
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (otp.trim() && !loading) {
                                handleVerifyOtp();
                              }
                            }}
                            disabled={!otp.trim() || loading}
                          >
                            {loading ? (t("loading") || "Loading...") : t("Basket.confirm")}
                          </button>
                          <button 
                            type="button" 
                            className="cancel" 
                            
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              if (!loading) {
                                localStorage.removeItem("phoneNumber");
                                props.setModal(false);
                              }
                            }}
                            disabled={loading}
                          >
                            {t("Basket.cancel")}
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
              </form>
            </div>

          )}
          {errorMsg && (
            <div
              style={{
                backgroundColor: "#ffe0e0",
                color: "#b30000",
                border: "1px solid #ffcccc",
                padding: "10px",
                borderRadius: "5px",
                marginTop: "10px",
                fontWeight: "bold",
                textAlign: "center",
                width: "100%",
                margin: "10px auto 0",
              }}
            >
              {errorMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PhoneModal;